const loaderScript = document.currentScript;
const formsSrc = loaderScript ? loaderScript.dataset.formsSrc : null;
let loadingPromise = null;

const loadForms = () => {
    if (!formsSrc || window.__hotvisaFormsReady) return Promise.resolve();
    if (loadingPromise) return loadingPromise;

    loadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement("script");
        script.src = formsSrc;
        script.defer = true;
        script.onload = resolve;
        script.onerror = reject;
        document.body.appendChild(script);
    });

    return loadingPromise;
};

window.addEventListener("hotvisa:load-forms", loadForms);

const observeInlineForms = () => {
    const selectors = [
        "form-feed",
        "form-contact",
        "form-thanks",
        "messenger-ctas",
        "trustindex-reviews",
        "visas",
        "socials",
    ];
    const elements = document.querySelectorAll(selectors.join(","));
    if (!elements.length) return;

    if (!("IntersectionObserver" in window)) {
        loadForms();
        return;
    }

    const observer = new IntersectionObserver((entries) => {
        if (entries.some((entry) => entry.isIntersecting)) {
            observer.disconnect();
            loadForms();
        }
    }, { rootMargin: "300px" });

    elements.forEach((element) => observer.observe(element));
};

document.addEventListener("DOMContentLoaded", observeInlineForms);
